import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const NuveiResult = () => {
  return <CommonResult />;
};

export default NuveiResult;
